/**
 * Input numerico tollerante: accetta virgola E punto come separatore decimale
 * (es. "38,20" / "38.20" / "38,20€") — pensato per prezzi e quantità.
 */
import React, { useState, useEffect } from "react";
import { Input } from "./ui/input";

export const parseDecimal = (raw) => {
  if (raw == null) return null;
  const s = String(raw).replace(/[€\s]/g, "").replace(/\./g, (m, i, str) => (str.includes(",") ? "" : m)).replace(",", ".");
  if (s === "" || s === "." || s === "-") return null;
  const n = parseFloat(s);
  return Number.isFinite(n) ? n : null;
};

export const DecimalInput = ({ value, onValue, className, ...props }) => {
  const [raw, setRaw] = useState(value == null || value === "" ? "" : String(value).replace(".", ","));

  useEffect(() => {
    const parsed = parseDecimal(raw);
    const v = value == null || value === "" ? null : Number(value);
    if (parsed !== v && !(raw === "" && (v === 0 || v == null))) {
      setRaw(v == null ? "" : String(v).replace(".", ","));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handle = (e) => {
    const t = e.target.value;
    if (!/^[0-9€\s.,-]*$/.test(t)) return;
    setRaw(t);
    const n = parseDecimal(t);
    onValue(n == null ? 0 : n);
  };

  return <Input type="text" inputMode="decimal" value={raw} onChange={handle} className={className} {...props} />;
};

export default DecimalInput;
